import { render, staticRenderFns } from "./RegistrationSuccessModal.vue?vue&type=template&id=aad715bc"
import script from "./RegistrationSuccessModal.vue?vue&type=script&lang=js"
export * from "./RegistrationSuccessModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports